export function formatDateWithOrdinal(date: Date): string {
  const day = date.getDate();

  const ordinal = (n: number): string => {
    if (n > 3 && n < 21) return "th";
    switch (n % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  };

  const monthYear = new Intl.DateTimeFormat("en-US", {
    month: "long",
    year: "numeric",
  }).format(date);

  return `${monthYear.split(" ")[0]} ${day}${ordinal(day)}, ${date.getFullYear()}`;
}